import { setter } from './utils';
import { SET_DEFAULT_PAGE_SIZE } from '../actions/types';
import { DEFAULT_PAGE_SIZE } from '../../client/constants';

/**
 * PDFDocumentProxy#getPage is async (so value can be 0)
 */
export default setter(SET_DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE);
